import React, { useEffect } from "react";
import { X } from "lucide-react";

export function Drawer({ open, onClose, title, subtitle, icon: Icon, tint = "bg-brand-soft text-brand", children, testid = "drawer", width = "max-w-lg" }) {
  useEffect(() => {
    if (!open) return undefined;
    const k = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[120]" data-testid={testid}>
      <div className="fade-in absolute inset-0 bg-slate-900/50 backdrop-blur-[2px]" onClick={onClose} data-testid={`${testid}-backdrop`} />
      <aside className={`absolute inset-y-0 right-0 flex w-full ${width} flex-col bg-white shadow-2xl`} style={{ animation: "slideInRight .25s ease both" }} role="dialog" aria-modal="true">
        <div className="flex items-start gap-3 border-b border-line p-5">
          {Icon && <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${tint}`}><Icon size={18} /></span>}
          <div className="min-w-0 flex-1">
            <p className="truncate text-base font-bold text-slate-900" data-testid={`${testid}-title`}>{title}</p>
            {subtitle && <p className="mt-0.5 text-xs text-slate-500">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700" aria-label="Tutup" data-testid={`${testid}-close`}><X size={18} /></button>
        </div>
        <div className="flex-1 space-y-6 overflow-y-auto p-5">{children}</div>
      </aside>
    </div>
  );
}

export function StatCard({ label, value, sub, testid, accent }) {
  return (
    <div className={`aivora-card p-5 ${accent ? "ring-1 ring-brand/20" : ""}`} data-testid={testid}>
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
      <p className="mt-2 text-2xl font-black text-slate-900">{value}</p>
      {sub && <p className="text-xs text-slate-500">{sub}</p>}
    </div>
  );
}

export function Badge({ children, tint = "bg-slate-100 text-slate-600", testid, className = "" }) {
  return <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold ${tint} ${className}`} data-testid={testid}>{children}</span>;
}
